import React from 'react';
import {StyleSheet, View, FlatList, Dimensions} from 'react-native';
import Localized from 'src/constants/AppStrings';
import Styles from '../../Styles';
import {CampusLocationType} from 'src/types/CampusLocationTypes';
import {IsConnectedProps} from 'src/types/Screen';
import VendingLocationView from 'src/components/elements/home/VendingLocationView';
import AVText from 'src/components/elements/AVText';
import {MachineType} from 'src/types/MachineType';
import {getDescriber} from './descriptor/DescriptorType';
import Settings from 'src/Settings';
import NewVendingLocationView from 'src/components/elements/home/NewVendingLocationView';

const width = Dimensions.get('window').width;

type VendingLocationListProps = IsConnectedProps & {
  locations: CampusLocationType[];
  onLocationClick: (machine, autoAdvanced?: boolean) => Promise<void>;
  onPlanogramClick?: (machine: MachineType) => void;
  isUnsupportedVendingLocation?: boolean;
};

const VendingLocationList = (props: VendingLocationListProps) => {
  const {getVendingTile} = getDescriber();
  const renderItem = ({item}) => {
    if (Settings.isRefiveAnd365Pay()) {
      return (
        <VendingLocationView
          location={item}
          onLocationClick={props.onLocationClick}
          onPlanogramClick={props.onPlanogramClick}
        />
      );
    } else {
      return (
        <NewVendingLocationView
          location={item}
          onLocationClick={props.onLocationClick}
          onPlanogramClick={props.onPlanogramClick}
          isOnlyTile={props.locations.length === 1}
        />
      );
    }
  };

  const getSmaContent = () => {
    return (
      <AVText
        accessibilityLabel={Localized.Labels.vending_sma}
        aria-label={Localized.Labels.vending_sma}
        style={getVendingTile()['vendingSmatxt']}
      >
        {Localized.Labels.vending_sma}
      </AVText>
    );
  };
  return (
    <View style={styles.container}>
      <View style={styles.headerView}>
        <AVText
          style={getVendingTile()['headerText']}
          accessible={true}
          accessibilityLabel={Localized.Labels.vending}
          accessibilityRole="text"
          aria-label={`${Localized.Labels.vending}, text`}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
        >
          {Localized.Labels.vending}
        </AVText>
      </View>
      {props.isUnsupportedVendingLocation && getSmaContent()}
      {props.locations.length > 0 && (
        <FlatList
          showsHorizontalScrollIndicator={false}
          horizontal={true}
          renderItem={renderItem}
          style={styles.campusLocationListView}
          data={props.locations}
          keyExtractor={(item, index) =>
            Localized.Labels.vending + item?.locationId + index
          }
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: Styles.Spacing.m3,
    flex: 1,
  },
  headerView: {
    width: width,
    marginLeft: Styles.Spacing.m3,
  },
  campusLocationListView: {},
});
export default VendingLocationList;
